const defaultJobs = [
  {
    id: 1,
    title: 'Full Stack Developer',
    postedDate: '2025-06-01',
    closingDate: '2025-07-01',
    location: 'Stamford, CT, USA',
    published: true,
    description: 'We are looking for an experienced Full Stack Developer with expertise in React, Node.js, and database technologies to join our growing team.',
  },
  {
    id: 2,
    title: 'Digital Marketing Specialist',
    postedDate: '2025-06-05',
    closingDate: '2025-07-05',
    location: 'Chennai, India',
    published: true,
    description: 'Seeking a Digital Marketing Specialist with experience in SEO, SEM, Social Media Marketing, and Content Strategy.',
  },
];

export const getJobs = () => {
  const stored = localStorage.getItem('egb_jobs');
  if (!stored) return defaultJobs;
  const jobs = JSON.parse(stored);
  // migrate old jobs that don't have published field
  const migrated = jobs.map(j => ({ published: true, ...j }));
  return migrated;
};

export const saveJobs = (jobs) => {
  localStorage.setItem('egb_jobs', JSON.stringify(jobs));
  window.dispatchEvent(new Event('storage'));
};
